import { jsonToQuery } from "../utils";
import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _SAVE_SCHOOL = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.SAVE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_SCHOOLS = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.LIST;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};

/* export const _LIST_SCHOOL_STATISTICS = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.LIST_STATISTICS;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
}; */

export const _SCHOOL_STATUS_UPDATE = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.UPDATE_STATUS;
  return callApi(url, "post", searchData && searchData);
};

export const _DELETE_SCHOOL = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.DELETE;
  return callApi(url, "post", searchData && searchData);
};

export const _UPDATE_SCHOOL = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.UPDATE;
  return callApi(url, "post", searchData && searchData);
};

export const _LIST_TRANSACTION = async (searchData = false) => {
  let url = ServiceUrl.SCHOOLS.SCHOOL.LIST_TRANSACTION;
  if (searchData) url += "?" + jsonToQuery(searchData);
  return callApi(url);
};
